import { z } from 'zod';
import { mongoObjectIdString } from './object-id-helpers.js';

export const VulnerabilitySchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    title: z.string().min(1, 'form.validation.nameRequired'),
    identifier: z.string().optional().or(z.literal('')),
    description: z.string().optional().or(z.literal('')),
    severity: z.enum(['critical', 'high', 'medium', 'low', 'informational']).default('medium'),
    relatedAssets: z.array(mongoObjectIdString).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateVulnerabilitySchema = VulnerabilitySchema.omit({ id: true });
export const UpdateVulnerabilitySchema = CreateVulnerabilitySchema.partial();
